import { defineFakeRoute } from 'vite-plugin-fake-server/client';

export default defineFakeRoute({
  url: '/register',
  method: 'post',
  response: () => ({
    data: { status: 'ok', currentAuthority: 'user' },
  }),
});
